module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/icon-crystal.e0f321ad.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/icon-crystal.png
// module id = 3072
// module chunks = 11